import LongText from '../Elements/LongText';
import React from 'react';

export default class ProjectChangeItem {
  constructor(item) {
    if (item) {
      this.CfId = item.cfId;
      this.CfName = item.cfName;
      this.CfLstname = item.cfLstname;
      this.CfStartDate = item.cfStartDate;
      this.CfEndDate = item.cfEndDate;
      return;
    }
    this.CfId = '';
    this.CfName = '';
    this.CfLstname = '';
    this.CfStartDate = '';
    this.CfEndDate = '';
  }

  static DateFields = ['CfStartDate', 'CfEndDate'];

  static FieldsToShowInDataTable() {
    return [
      { label: 'Selected', orderById: '', data: ProjectChangeItem.getSelectedCellContent, minWidth: 20 },
      { label: 'Project ID', orderById: 'CfId', data: 'CfId' },
      { label: 'Project', orderById: 'CfName', data: (item) => <LongText text={item.CfName} maxLength={30} /> },
      { label: 'Start On', orderById: 'CfStartDate', data: 'CfStartDate' },
      { label: 'End On', orderById: 'CfEndDate', data: 'CfEndDate' },
      {
        label: 'Service Type',
        orderById: 'CfLstname',
        data: (item) => <LongText text={item.CfLstname} maxLength={30} />
      }
    ];
  }

  static getSelectedCellContent(item) {
    if (item.Selected === undefined) item.Selected = false;
    return (
      <div className='text-center'>
        <input
          type='radio'
          checked={item.Selected}
          onClick={(e) => {
            ProjectChangeItem.clickOnSelect(item);
          }}
          onChange={(e) => {}} //Don't remove. This is necessary to eliminate the React warning!
        />
      </div>
    );
  }

  static clickOnSelect(item) {
    alert('Click');
  }
}
